<template>
    <div class="heart-icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 335.48 305.6" style="enable-background:new 0 0 335.48 305.6;" xml:space="preserve">
        <path :stroke="colors.theme == 'dark' ? '#fff' : '#000'" class="heart-svg" d="M329.18,99.02c0-51.29-39.07-92.88-87.27-92.88c-31.16,0-58.51,17.39-73.95,43.54l0,0l0,0
            C152.51,23.53,125.16,6.14,94,6.14c-48.2,0-87.27,41.58-87.27,92.88c0,3.05,0.14,6.06,0.41,9.04l0,0
            c6.04,85.53,160.82,187.36,160.82,187.36s154.78-101.83,160.82-187.36l0,0C329.04,105.08,329.18,102.07,329.18,99.02z"/>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
    }
}
</script>

<style lang="scss" scoped>
.heart-svg{
    fill: none;
}
</style>
